var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.spans),function(span,idx){return _c('span',{key:idx,class:span.classes},[_vm._v(_vm._s(span.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }